import { Radio, Form } from 'antd';
import React, { useEffect, useState } from 'react';
import type { RadioChangeEvent } from 'antd';
import '../SurveyAnswer.less';

// 逻辑切换 - 清除关联题目逻辑id集合
let delIds: string[] = [];

// 量表题
const Scale = ({
    body = '您对此调查项目的评价',
    required,
    id,
    optionList,
    num,
    questionLogicsEntity,
    setDataList,
    dataList,
    dataListRef,
    initForm,
}: {
    body?: string;
    required?: boolean;
    optionList?: Array<string>;
    num?: number;
    id?: number;
    questionLogicsEntity: any;
    setDataList: any;
    dataList?: [];
    dataListRef?: [];
    initForm?: any;
}) => {
    const [value, setValue] = useState();
    const onChange = (e: RadioChangeEvent) => {
        setValue(e.target.value);
    };

    // 判断当前选项是否存在跳转逻辑
    const getCurrentOption = (logicsEntity: any, value?: number) => {
        let arr = logicsEntity.filter((item: any) => item.optionId === value);
        if (arr && arr.length) {
            return arr[0];
        }
        return null;
    };

    // 回显 - 数据缓存
    useEffect(() => {
        if (optionList && optionList.length) {
            if (initForm) {
                const val = initForm[`${id}-8`];
                if (val) {
                    let resVal: any = Number(val);
                    setValue(resVal);
                }
            } else {
                let answer;
                let selectArr: any[] = optionList.filter((it: any) => it.selected);
                answer = selectArr && selectArr.length ? selectArr[0].id : '';
                setValue(answer);
            }
        }
    }, [optionList, initForm]);

    // 深度遍历 - 嵌套逻辑子级 - 清除隐藏题目关联逻辑
    const dealChildrenLogic = (optionTarget: any, list: any[]) => {
        if (optionTarget.targetQuestionId) {
            let startIndex!: number, endIndex!: number;
            list.forEach((item: any, index: number) => {
                if (optionTarget.sourceQuestionId === item.id) {
                    startIndex = index;
                }
                if (optionTarget.targetQuestionId === item.id) {
                    endIndex = index;
                }
            });
            list.forEach((item: any, i: number) => {
                if (i > startIndex && i < endIndex) {
                    if (!delIds.includes(`topicId-${item.id}`)) {
                        delIds.push(`topicId-${item.id}`);
                    }
                    if (item.questionLogicsEntity) {
                        dealChildrenLogic(item.questionLogicsEntity[0], list);
                    }
                } else if (!endIndex && i > startIndex) {
                    if (!delIds.includes(`topicId-${item.id}`)) {
                        delIds.push(`topicId-${item.id}`);
                    }
                }
            });
        }
    };

    // 逻辑切换 - 清除隐藏题目关联逻辑
    const dealLogic = (list: any[]) => {
        const current = value;
        if (current) {
            const topicId = id;
            if (value) {
                const optionId = value;
                const curItem: any = list.filter((item: any) => item.id === topicId) || [];
                if (curItem.length && curItem[0].id === topicId && curItem[0].questionLogicsEntity) {
                    let optionTarget = getCurrentOption(curItem[0].questionLogicsEntity, Number(optionId));
                    if (optionTarget) {
                        // 获取当前逻辑选中题目的end下标
                        let currentEndIndex!: number;
                        list.forEach((item: any, index: number) => {
                            if (optionTarget.targetQuestionId === item.id) {
                                currentEndIndex = index;
                            }
                        });

                        dealChildrenLogic(optionTarget, list);
                        console.log(delIds);
                        const resDelIds = delIds.filter((delId: string) => {
                            const curIndex = list.findIndex((it: any) => delId === `topicId-${it.id}`);
                            if (currentEndIndex) {
                                return curIndex <= currentEndIndex;
                            } else {
                                return curIndex;
                            }
                        });

                        // 跳转到结束
                        let resultList: any = [];

                        resultList = list.map((item: any, i: number) => {
                            let newItem = { ...item };
                            let keys: any = Object.keys(newItem);
                            let isShowTopic: any = keys.filter((it: any) => it.includes('topicId'));
                            let isShowTopicTarget: any = keys.filter((it: any) => it.includes('isShow'));
                            let isDel = isShowTopic.filter((it: string) => resDelIds.includes(it));
                            let isShow = isShowTopicTarget.filter((it: string) => {
                                const showId = `topicId-${it.split('-')[1]}`;
                                return it && resDelIds.includes(showId);
                            });
                            console.log(isDel, isShow);
                            if ((isDel && isDel.length) || (isShow && isShow.length)) {
                                delete newItem[isDel[0]];
                                delete newItem[isShow[0]];
                            }
                            return newItem;
                        });
                        return resultList;
                    }
                    return list;
                }
                return list;
            }
            return list;
        }
        return list;
    };

    // 监听 - 量表逻辑跳转
    useEffect(() => {
        if (questionLogicsEntity && dataList && dataList.length && dataListRef && value) {
            let initList: any = [];
            console.log(dataList);
            initList = dataList.map((item: any, i: number) => {
                let newItem = { ...item };
                let keys: any = Object.keys(item);
                let isShowTopic: any = keys.filter((it: any) => it.includes('topicId') || it.includes('isShow'));
                if (isShowTopic && isShowTopic.length) {
                    console.log(`topicId-${id}`);
                    delete newItem[`topicId-${id}`];
                    delete newItem[`isShow-${id}`];
                }
                return newItem;
            });
            // setDataList([...resultList]);

            let optionTarget = getCurrentOption(questionLogicsEntity, value);
            if (optionTarget) {
                // 跳转到结束
                if (optionTarget.targetQuestionId === -1) {
                    let startIndex!: number;
                    initList.forEach((item: any, index: number) => {
                        if (optionTarget.sourceQuestionId === item.id) {
                            startIndex = index;
                        }
                    });
                    let resultList: any = [];
                    resultList = initList.map((item: any, i: number) => {
                        let newItem = { ...item };
                        if (i > startIndex) {
                            newItem[`topicId-${id}`] = true;
                        }
                        return newItem;
                    });
                    if (localStorage.getItem('currentChangeTopic') === String(id)) {
                        setDataList([...resultList]);
                    } else {
                        delIds = [];
                        const resList = dealLogic(resultList);
                        setDataList([...resList]);
                    }

                    // 跳转下一题
                } else {
                    let startIndex!: number, endIndex!: number;
                    initList.forEach((item: any, index: number) => {
                        if (optionTarget.sourceQuestionId === item.id) {
                            startIndex = index;
                        }
                        if (optionTarget.targetQuestionId === item.id) {
                            endIndex = index;
                        }
                    });
                    let resultList: any = [];
                    resultList = initList.map((item: any, i: number) => {
                        let newItem = { ...item };
                        if (i > startIndex && i < endIndex) {
                            newItem[`topicId-${id}`] = true;
                        }
                        if (i === endIndex) {
                            newItem[`isShow-${id}`] = true;
                        }
                        return newItem;
                    });
                    if (localStorage.getItem('currentChangeTopic') === String(id)) {
                        setDataList([...resultList]);
                    } else {
                        delIds = [];
                        const resList = dealLogic(resultList);
                        setDataList([...resList]);
                    }
                }
            } else {
                delIds = [];
                const resList = dealLogic(initList);
                setDataList([...resList]);
            }
        }
    }, [questionLogicsEntity, value, dataListRef]);

    return (
        <div>
            <Form.Item
                name={`${id}-8`}
                rules={[
                    {
                        required,
                        message: '该题为必答题，请作答后提交。',
                    },
                ]}
                label={<div style={{ display: 'flex' }} dangerouslySetInnerHTML={{ __html: `<span class="title-num">${num}.</span>` + `<span>${body}</span>` }}></div>}
            >
                <div className="scale-topic">
                    <div className="scale-content">
                        <Radio.Group onChange={onChange} value={value}>
                            {optionList && optionList.length
                                ? optionList.map((option: any) => (
                                      <Radio.Button value={option.id} key={option.id}>
                                          {option.content}
                                      </Radio.Button>
                                  ))
                                : null}
                        </Radio.Group>
                    </div>
                    <p className="scale-tips">
                        <span>非常不满意</span>
                        <span>非常满意</span>
                    </p>
                </div>
            </Form.Item>
        </div>
    );
};

export default Scale;
